import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Grid from "../../assets/Grid.png";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { Script } from "../../Utils/Script";


const PrivacyPolicy = () => {
  const sections = [
    { id: "who-we-are", label: "Who we are" },
    { id: "purpose-of-data-processing", label: "Purpose of Data Processing" },
    { id: "information-we-collect", label: "Information We Collect" },
    { id: "driver-personal-data-collected", label: "Driver personal data collected" },
    { id: "location-data", label: "Location Data" },
    { id: "vehicle-information", label: "Vehicle Information" },
    { id: "background-check-information", label: "Background Check Information" },
    { id: "customer-personal-data-collected", label: "Customer personal data collected" },
    { id: "how-we-use-your-information", label: "How We Use Your IAnformation" },
    { id: "customer-support-and-communication", label: "Customer Support and Communication" },
    { id: "use-of-cookies", label: "Use of Cookies" },
  ];

  const [activeSection, setActiveSection] = useState(sections[0].id);

  const handleTocClick = (id) => {
    setActiveSection(id);
    const element = document.getElementById(id);

    if (element) {
      const yOffset = -120;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      let currentSection = sections[0].id;

      for (const section of sections) {
        const element = document.getElementById(section.id);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 140) {
            currentSection = section.id;
          }
        }
      }

      setActiveSection(currentSection);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
  Script();
}, []);

  return (
    <>
    <Helmet>
        <title>Privacy Policy — How Packky Collects & Protects Your Data </title>

        <meta
          name="description"
          content="Understand how Packky (powered by Chaafo) collects, uses, and protects personal data for delivery partners and customers in compliance with Indian data protection laws."
        />
      </Helmet>
    <Navbar/>
      <div className="w-full">
        <section>
          <div
  className="mx-auto flex h-[320px] w-full items-center px-4 sm:h-[260px] sm:px-8 md:h-[300px] md:px-16 lg:h-[320px] lg:px-20"
  style={{
    background:
      "linear-gradient(180deg, #fff 0, #0000), radial-gradient(circle at 10% 100%, #8cffdd 0, #0000 30%), radial-gradient(circle at 40% 100%, #ff8cd1 0, #0000 40%), radial-gradient(circle at 100% 100%, #c68cff 0, #0000 55%)",
  }}
>
  <div>
    <p className="mb-4 mt-28 text-[20px] font-medium text-[#6b6b6b] sm:mt-20 sm:text-[24px] md:mt-24 md:text-[28px]">
      Packky (powered by Chaafo)
    </p>

    <h2 className="text-[22px] font-bold uppercase leading-none !text-gray-700 sm:text-[24px] md:text-[26px]">
      PRIVACY POLICY
    </h2>
  </div>
</div>
        </section>
      </div>

   <div
  className="bg-[#ffeef8] bg-no-repeat bg-top px-3 py-6 sm:px-4 sm:py-8 md:py-10"
  style={{
    backgroundImage: `url(${Grid})`,
    backgroundSize:
      window.innerWidth < 640
        ? "1100px auto"
        : window.innerWidth < 1024
          ? "1600px auto"
          : "2500px auto",
    backgroundPosition: "top center",
  }}
>
        <div>
          <section className="mx-auto max-w-[1720px] px-0 py-6 sm:px-2 md:px-4 lg:px-10 lg:py-12">
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-12">
           <aside className="hidden lg:col-span-4 lg:block xl:col-span-4">
                <div className="lg:sticky lg:top-[110px]">
                  <div className="rounded-2xl bg-white p-6 shadow-sm">
                    <h3 className="mb-5 text-[18px] font-semibold leading-tight text-[#f97936]">
                      Table of Content
                    </h3>

                    <ul className="space-y-2">
                      {sections.map((section) => (
                        <li key={section.id}>
                          <button
                            type="button"
                            onClick={() => handleTocClick(section.id)}
                           className={`w-full rounded-xl px-4 py-3 text-left text[20px] transition ${
                              activeSection === section.id
                                ? "bg-[#f0e3da] font-semibold text-[#f97936]"
                                : "text-gray-600 hover:bg-gray-100"
                            }`}
                          >
                            {section.label}
                          </button>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </aside>

             <main className="lg:col-span-8 xl:col-span-8">
  <div className="pt-0">
    <div className="privacy-card rounded-2xl bg-white p-4 sm:p-6 md:p-8 lg:p-10">
                  <h6 className="px-0 py-3 text-2xl font-bold text-[#f97936] sm:text-3xl lg:px-5">
  Introduction :
</h6>

                    <div className="mt-4">
                      <div className="mb-3 flex items-start gap-2">
  <div className="min-w-[18px] font-bold">1.</div>
                        <div className="text-[16px] text-[#525252]">
  This Privacy Policy explains how Packky (powered by Chaafo){" "}
  
  <a
    href="https://packky.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-600 underline"
  >
    https://packky.com
  </a>{" "}
  
  collects, uses, stores, shares, and processes the personal data Packky
  (powered by Chaafo) gathers when you are on our sites and using our apps
  that refer to or link to the Privacy Policy.
</div>
                      </div>
                  <div className="mb-3 flex items-start gap-2">
  <div className="min-w-[18px] font-bold">2.</div>
                        <div
                          className="text-[16px] text-[#6b6b6b]"
                          // style={{ maxWidth: "50rem" }}
                        >
                          This Privacy Policy will take effect from the date indicated above. We
                          may, at a future time, amend the Privacy Policy. If we do amend the
                          Privacy Policy, we shall post the updated Privacy Policy on this page (or
                          a linked page) and change the date at the beginning of this page. We
                          invite you to return to this date when you are on our website to seek
                          changes and revisions to this Privacy Policy. Your access to or use of
                          the site or our Services after changes have been posted to this Privacy
                          Policy (and not earlier, if changes have been made) will be considered
                          your acceptance of the changes.
                        </div>
                      </div>
                    </div>

                    <h6
                      id="who-we-are"
                      className="scroll-mt-[120px] text-[#525252] pb-2 pt-2 text-xl font-semibold"
                    >
                      Who we are :
                    </h6>

                    <div className="mt-4">
                      <div className="mb-3 flex items-start gap-2">
  <div className="min-w-[18px] font-bold">1.</div>
                        <div
                          className="text-[16px] text-[#6b6b6b]"
                          // style={{ maxWidth: "51rem" }}
                        >
                          At Packky (powered by Chaafo), we are the only delivery service provider
                          that is dedicated to bridging Restaurants and customers with reliable
                          delivery partners. Our system allows independent contractors to
                          effectively deliver services and products to customers while guaranteeing
                          on-time and consistent delivery experiences. We aim to provide
                          flexibility and independence for our delivery partners as well as give
                          businesses and individuals exceptional service.
                        </div>
                      </div>
                  <div className="mb-3 flex items-start gap-2">
  <div className="min-w-[18px] font-bold">2.</div>
                        <div
                          className="text-[16px] text-[#6b6b6b]"
                          // style={{ maxWidth: "51rem" }}
                        >
                          Our goal is to create a strong, user-centric ecosystem that enables
                          delivery partners to succeed while providing excellent service to our
                          customers. Through the use of cutting-edge technology, data analysis, and
                          a committed team, we will strive to constantly improve the delivery
                          process and lead innovation in the logistics sector.
                        </div>
                      </div>
                      <div className="mb-3 flex items-start gap-2">
  <div className="min-w-[18px] font-bold">3.</div>
                        <div
                          className="text-[16px] text-[#6b6b6b]"
                          // style={{ maxWidth: "52rem" }}
                        >
                          Whether you are a delivery partner wanting to become part of our network
                          or a customer requiring secure delivery services, Packky (powered by
                          Chaafo) is here to offer a smooth and efficient experience for everyone.
                        </div>
                      </div>
                    </div>

                    <h6
                      id="purpose-of-data-processing"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Purpose of Data Processing :
                    </h6>

                    <div className="mb-3 flex">
                      <div className="text-[16px]" >
                        So that we can collect all data from our delivery partners, Drivers, and
                        Customers when they register to use our Services and during the provision
                        of those Services. We also gather personal information from various groups
                        of individuals, including prospective and past Drivers and Customers, other
                        companies and persons who could be related or associated with them,
                        visitors to our premises, and other persons who could interact with us in
                        the course of carrying out our business. The collection of such
                        information is aimed at ensuring and improving the delivery of the Services
                        to our Drivers and Customers.
                      </div>
                    </div>

                    <h6
                      id="information-we-collect"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Information We Collect :
                    </h6>

                    <p className="font-bold text-[18px] text-[#525252]">
                      We gather the following categories of information:
                    </p>

                  <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Personal Information:
  </span>
  When you sign up as a delivery partner, we obtain your name, contact
  information (phone number and email address), delivery preferences, and
  payment information.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Location Data:
  </span>
  To facilitate deliveries, we may collect your real-time location
  information through the website or mobile app when you accept delivery
  requests.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Device Information:
  </span>
  We may collect information about the device you use to access our website,
  such as your IP address, browser type, device identifiers, and usage data.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Transaction Data:
  </span>
  We collect information related to the deliveries you complete, including
  delivery history, earnings, and payment transactions.
</p>
                    

                    <h6
                      id="driver-personal-data-collected"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Driver personal data collected:
                    </h6>

                    <h6 className="font-bold text-[18px] text-[#525252]">
                      Identification and Contact Information such as
                    </h6>

                   <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Full Name:
  </span>
  To identify you as a delivery partner and ensure proper records.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Email Address:
  </span>
  To communicate important updates, service notifications, and support
  requests.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Phone Number:
  </span>
  To contact you regarding deliveries, urgent updates, or customer service
  needs.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Profile Picture:
  </span>
  A photo for identification purposes on the platform.
</p>
                    

                    <h6
                      id="location-data"
                      className="scroll-mt-[120px] pt-2 pb-2 font-bold text-xl text-[#525252]"
                    >
                      Location Data
                    </h6>

                   <p className=" text-[16px] text-[#6b6b6b]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Real-Time Location:
  </span>
  To assign and track deliveries, optimize routes, and ensure timely
  delivery. This data may be collected through GPS or other tracking
  technologies while you are using the platform.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Delivery Route Information:
  </span>
  Information about the routes you take for deliveries may also be collected
  for logistical purposes and efficiency improvement.
</p>
                    

                    <h6 className="font-bold pb-2 pt-2 text-xl text-[#525252]">
                      Driver’s License and Identification Documents:
                    </h6>

                    <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Driver’s License Number:
  </span>
  To verify that you have a valid driver’s license and are legally allowed
  to drive.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-base text-[#525252] mr-1">
    Government-Issued ID:
  </span>
  For age verification and additional identity checks to ensure you meet
  platform requirements and local regulations.
</p>
                    

                    <h6
                      id="vehicle-information"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Vehicle Information:
                    </h6>

                    <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Vehicle Type and License Plate Number:
  </span>
  To verify the vehicle you will be using for deliveries and ensure it meets
  company and legal standards.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Insurance Details:
  </span>
  Information related to your vehicle’s insurance coverage, if applicable,
  to ensure compliance with local laws and platform requirements.
</p>

                    <h6
                      id="background-check-information"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Background Check Information:
                    </h6>

                   <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Criminal History (if applicable):
  </span>
  For security and safety purposes, we may conduct background checks
  (subject to local regulations) to verify your suitability as a delivery
  partner.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Driving History:
  </span>
  To verify your driving record and ensure that you are a responsible driver
  with a safe history.
</p>
                    

                    <h6
                      id="customer-personal-data-collected"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Customer personal data collected:
                    </h6>

                    <p className="text-[16px] text-[#525252]">
                      We obtain the following personal data from Customers (individuals and
                      businesses), which includes but is not limited to.
                    </p>

                    <p className="text-[16px] text-[#525252]">
                      Customer information including; full name, address, telephone number,
                      company name (optional), email address.
                    </p>

                    <p className="text-[16px] text-[#525252]">
                      Pick-up details for each Job Request, including; sender name, contact
                      telephone number, pick-up address, what3words (optional), pick-up date and
                      time, duration of hire (if applicable), whether they need assistance with
                      loading/unloading item.
                    </p>

                    <p className="text-[16px] text-[#525252]">
                      Drop-off details for each Job Request, including; recipient name, contact
                      telephone number, drop-off address, drop-off date and time.
                    </p>

                    <p className="text-[16px] text-[#525252]">
                      Drop-off items including; package size, weight and quantity and whether they
                      need help/two man assistance with loading/unloading items, cost of goods.
                    </p>

                 <p
  id="how-we-use-your-information"
  className="scroll-mt-[120px] pt-2 pb-2 text-[16px] text-[#6b6b6b]"
>
  <span className="font-bold text-xl text-[#525252] mr-1">
    How We Use Your Information:
  </span>
  We use your information for the following purposes
</p>
                    

                 <p className="text-[16px] text-[#6b6b6b] leading-6">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Use of Location Data:
  </span>
  We collect location data in the background to support delivery tracking
  for registered drivers. This data is not shared with third parties and is
  only used for operational purposes.
</p>

                 <p className="text-[16px] text-[#6b6b6b] leading-6">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
                      To Provide Services:</span>
                        {" "}
                        We use your personal information to enable your participation as a
                        delivery partner, including matching you with delivery requests,
                        processing payments, and communicating with you about delivery-related
                        matters.
                      </p>
                    

                 <p className="text-[16px] text-[#6b6b6b] leading-6">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
                      To Improve Our Services:</span>
                        {" "}
                        We may analyze usage data to improve the website’s functionality, enhance
                        user experience, and optimize delivery operations.
                      </p>
                    

                   <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    To Communicate with You:
  </span>
  We may send you updates, notifications, and promotional materials about our services. You can opt out of receiving marketing communications at any time.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Legal Compliance:
  </span>
  We process personal and transactional data to comply with applicable laws and regulations, including tax obligations, data protection laws, and labor laws.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Sharing Your Information:
  </span>
  We do not sell your personal information. However, we may share your information in the following situations:
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    With Service Providers:
  </span>
  We may share your data with trusted third-party service providers who assist us in operating our website and providing services (e.g., payment processors, data storage providers).
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    For Legal Reasons:
  </span>
  We may disclose your information if required to do so by law, to enforce our terms of service, or to protect the rights, property, or safety of the website, our users, or others.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    With Business Transfers:
  </span>
  In the event of a merger, acquisition, or sale of our business, your personal information may be transferred as part of the transaction.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Security of Your Information:
  </span>
  We take reasonable steps to protect your personal information from unauthorized access, use, or disclosure. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Cookies and Tracking Technologies:
  </span>
  We use cookies and similar tracking technologies to improve the functionality of our website and to analyze user behavior. You can manage your cookie preferences through your browser settings.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Third-Party Links:
  </span>
  Our website may contain links to third-party websites that are not operated by us. We are not responsible for the privacy practices of these external sites. We encourage you to review the privacy policies of those sites before providing any personal information.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Age Restriction:
  </span>
  To ensure a safe and legally compliant experience, our platform has an age restriction for delivery partners. The following guidelines apply:
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Minimum Age Requirement:
  </span>
  You must be at least 18 years of age to register as a delivery partner on our platform. This is because delivery work involves legal contracts, financial transactions, and other responsibilities that require you to be legally considered an adult.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Proof of Age:
  </span>
  During the registration process, we may ask for proof of your age, such as a valid government-issued ID or another form of identification to verify your eligibility.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="font-bold text-[16px] text-[#525252] mr-1">
    Legal Compliance:
  </span>
  We comply with local, state, and national regulations regarding the minimum age for employment and contracting. If you do not meet the age requirement, you will not be able to use our platform as a delivery partner.
</p>

<p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
  <span className="mr-1 text-[16px] font-bold text-[#525252]">
    Marketing:
  </span>

  We may use your personal data to contact you with email or SMS
  newsletters, marketing or promotional materials and other information
  that may be of interest to you. Unless you opt out of receiving any, or
  all, of these communications from us by emailing us using the
  information noted at the foot of this document, which you can do so at
  any time. If you do not wish to receive such communications, please let
  us know in writing by sending an email to{" "}

  <a
    href="mailto:info@packky.com"
    className="font-medium text-blue-600 underline"
  >
    info@packky.com
  </a>
</p>

                    <h6
                      id="customer-support-and-communication"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Customer Support and Communication:
                    </h6>

                    <p className="text-[16px] text-[#525252]">
                      Personal contact details are processed to facilitate communication between
                      delivery partners, customers, and the platform, such as providing updates on
                      delivery status or resolving issues.
                    </p>

                    <p className="break-words text-[15px] leading-7 text-[#6b6b6b] sm:text-[16px]">
                      We use data to handle customer inquiries or complaints related to delivery
                      experiences.
                    </p>

                    <h6
                      id="use-of-cookies"
                      className="scroll-mt-[120px] pb-2 pt-2 font-bold text-xl text-[#525252]"
                    >
                      Use of Cookies:
                    </h6>

                    <p className="text-[16px] text-[#525252]">
                      Packky (powered by Chaafo) uses cookies and similar tracking technologies to
                      enhance your experience on our platform, improve functionality, and analyze
                      website usage. By accessing or using the Packky (powered by Chaafo)
                      platform, you consent to the use of cookies as described in this policy.
                      Packky (powered by Chaafo) may update this
                      <span className="font-bold"> Cookie Policy</span> from time to time to
                      reflect changes in our practices or legal requirements. We will notify you
                      of any significant changes and encourage you to review this policy
                      periodically to stay informed about how we use cookies.
                    </p>
                  </div>
                </div>
              </main>
            </div>
          </section>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default PrivacyPolicy;